import styled from 'styled-components'
import { View } from 'react-native'

const AppContainer = styled(View)`
  input {
    outline: none;
  }
  * ::-webkit-scrollbar-track {
    background-color: transparent;
  }
  * ::-webkit-scrollbar {
    width: 6px;
    height: 0px;
    background-color: transparent;
  }

  * :hover::-webkit-scrollbar-thumb {
    background-color: #d5d5d5;
    border-radius: 10px;
  }

  #front-chat-container {
    z-index: 1!important;
  }

  .trimblemaps-ctrl {
    display: none;
  }
`
export {
  AppContainer
}
